import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import ConsentsSectionStart from './index';
import { SectionStatus } from '../../../sections/types';
import { IProps } from '.';

const mapStateToProps = (state: ApplicationState): IProps => {
  const personalStarted = state.student.offer.isPISectionStarted;
  const historyStarted = state.student.offer.isHSectionStarted;
  const consentsStarted = state.student.consents.isSectionStarted;

  const personalComplete = state.student.offer.isPISectionComplete;
  const historyComplete = state.student.offer.isHSectionComplete;
  const consentsComplete = state.student.consents.isSectionComplete;

  return {
    personalInfoStatus: personalComplete
      ? SectionStatus.complete
      : personalStarted
        ? SectionStatus.incomplete
        : SectionStatus.empty,
    historyStatus: historyComplete
      ? SectionStatus.complete
      : historyStarted
        ? SectionStatus.incomplete
        : SectionStatus.empty,
    consentsStatus: consentsComplete
      ? SectionStatus.complete
      : consentsStarted
        ? SectionStatus.incomplete
        : SectionStatus.empty,
  };
};

export default connect(mapStateToProps)(ConsentsSectionStart);
